<template>
  <div class="card">
    <div class="card-header border-0 pt-6">
      <!--begin::Card toolbar-->
      <div class="card-toolbar">
        <!--begin::Toolbar-->
        <div
          class="d-flex justify-content-end"
          data-kt-customer-table-toolbar="base"
        >
          <!--begin::Add-->
          <button
            type="button"
            class="btn btn-primary mx-6"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_filiation"
          >
            <span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotone/Navigation/Plus.svg" />
            </span>
            Nueva filiación
          </button>
          <div class="btn-group dropend">
            <button
              type="button"
              class="btn btn-success dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Graficar
            </button>
            <ul class="dropdown-menu">
              <li>
                <a
                  class="dropdown-item"
                  type="button"
                  @click="getSelectedData(1)"
                  >Barras</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item"
                  type="button"
                  @click="getSelectedData(2)"
                  >Torta</a
                >
              </li>
            </ul>
          </div>
          <div v-if="loading">
            <pulse-loader
              :loading="loading"
              color="green"
              size="20px"
            ></pulse-loader>
          </div>
          <!--end::Add customer-->
        </div>
        <!--end::Toolbar-->
      </div>
      <!--end::Card toolbar-->
    </div>

    <div class="card-body pt-0">
      <DxDataGrid
        id="gridContainer"
        ref="dataGridRef"
        :data-source="listPpl"
        key-expr="id_persona"
        :allow-column-reordering="false"
        :row-alternation-enabled="true"
        :show-borders="true"
        @exporting="onExporting"
      >
        <DxFilterRow :visible="true" />
        <DxPager
          :visible="true"
          :allowed-page-sizes="pageSizes"
          :show-page-size-selector="true"
        />
        <DxPaging :page-size="10" />
        <DxGroupPanel :visible="true" />
        <DxGrouping :auto-expand-all="false" />
        <DxExport :enabled="true" :allow-export-selected-data="true" />
        <DxSelection mode="multiple" />
        <DxColumn
          :width="140"
          :allow-sorting="false"
          caption="Acciones"
          cell-template="cellTemplate"
        />
        <template #cellTemplate="{ data }">
          <button
            type="button"
            class="btn btn-outline-primary"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_filiation"
            @click="editData(data.data)"
          >
            <i class="fas fa-edit"></i>
          </button>
        </template>
        <DxColumn :width="130" data-field="nombres" :allow-grouping="false" />
        <DxColumn
          :width="130"
          data-field="primer_apellido"
          :allow-grouping="false"
        />
        <DxColumn
          :width="130"
          data-field="segundo_apellido"
          :allow-grouping="false"
        />
        <DxColumn :width="170" data-field="tipo_documento" />
        <DxColumn
          :width="130"
          data-field="nro_documento"
          :allow-grouping="false"
        />
        <DxColumn
          :width="70"
          data-field="complemento"
          caption="Comp."
          :allow-grouping="false"
        />
        <DxColumn
          :width="130"
          data-field="fecha_nacimiento"
          data-type="date"
          :format="DateFormat"
        />
        <DxColumn :width="100" data-field="genero" />
        <DxColumn :width="100" data-field="pais" />
        <DxColumn :width="130" data-field="departamento" />
        <DxColumn
          :width="150"
          data-field="nombre"
          caption="Centro Penitenciario"
        />
        <DxColumn
          :width="235"
          data-field="centro_dep"
          caption="Departamento Centro Penitenciario"
        />
        <DxColumn
          :width="280"
          data-field="descripcion_delito"
          caption="Delito"
        />
        <DxColumn
          :width="130"
          data-field="fecha_admision"
          data-type="date"
          :format="DateFormat"
        />
        <DxColumn
          :width="130"
          data-field="situacion_legal"
          caption="Situación Jurídica"
        />
        <DxColumn
          :width="120"
          data-field="anios_sentencia"
          caption="Años sentencia"
        />
        <DxColumn
          :width="120"
          data-field="meses_sentencia"
          caption="Meses sentencia"
        />
        <DxColumn
          :width="120"
          data-field="jurisdiccion_caso"
          caption="Jurisdicción"
        />
        <DxColumn :width="170" data-field="juez_caso" caption="Juez" />
        <DxColumn :width="120" data-field="juzgado_caso" caption="Juzgado" />
        <DxColumn
          :width="150"
          data-field="grado_instruccion"
          caption="Grado de instrucción"
        />
        <DxColumn :width="150" data-field="idioma_primario" caption="Idioma" />
        <DxColumn
          :width="150"
          data-field="identidad_etnica"
          caption="Identidad étnica"
        />
        <DxColumn
          :width="150"
          data-field="orientacion_sexual"
          caption="Identidad sexual"
        />
        <DxColumn :width="120" data-field="enfermedad" />
        <DxGroupPanel :visible="true" />
        <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
        <DxSummary>
          <DxGroupItem
            column="jurisdiccion_caso"
            summary-type="count"
            display-format="{0} Persona(s) Privada de Libertad"
          />
          <DxTotalItem
            column="cod_persona"
            summary-type="count"
            display-format="Total count: {0} Personas privadas de libertad"
          />
        </DxSummary>
        <DxSortByGroupSummaryInfo summary-item="primer_apellido" />
      </DxDataGrid>
    </div>
  </div>
  <DxChart
    v-if="chartStatus == 'one' && typeChart == 'barras'"
    id="chart"
    palette="Soft"
    :data-source="chartDataValues"
    title="Sistema de registro penitenciario"
  >
    <DxSeriesTemplate name-field="nombre" />
    <DxCommonSeriesSettings
      :ignore-empty-points="true"
      argument-field="nombre"
      value-field="count"
      type="bar"
    >
      <DxLabel :visible="true" background-color="#c18e92" />
    </DxCommonSeriesSettings>
    <DxArgumentAxis :tick-interval="200" title="">
      <DxLabel :rotation-angle="80" display-mode="rotate" />
    </DxArgumentAxis>
    <DxValueAxis :tick-interval="100" title="Número PPL"></DxValueAxis>
    <DxLegend :visible="false" />
    <DxExport :enabled="true" />
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltip1"
      location="edge"
    />
  </DxChart>
  <DxChart
    v-if="chartStatus == 'two' && typeChart == 'barras'"
    id="chart1"
    palette="Soft"
    :data-source="chartDataTwoParams.dataBars"
    title="Sistema de registro penitenciario"
  >
    <DxSeriesTemplate name-field="data1" />
    <DxCommonSeriesSettings
      :ignore-empty-points="true"
      argument-field="data2"
      value-field="count"
      type="bar"
    >
      <DxLabel :visible="true" background-color="#c18e92" />
    </DxCommonSeriesSettings>
    <DxArgumentAxis :tick-interval="500" title="">
      <DxLabel :rotation-angle="80" display-mode="rotate" />
    </DxArgumentAxis>
    <DxValueAxis :tick-interval="500" title="Número PPL"></DxValueAxis>
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltip"
      location="edge"
    />
    <DxExport :enabled="true" />
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxLegend
      :visible="true"
      vertical-alignment="bottom"
      horizontal-alignment="center"
    />
  </DxChart>
  <DxPieChart
    v-if="chartStatus == 'one' && typeChart == 'torta'"
    id="pie"
    :data-source="chartDataValues"
    palette="Bright"
    title="Sistema de registro penitenciario"
    @point-click="pointClickHandler($event)"
    @legend-click="legendClickHandler($event)"
  >
    <DxSeries argument-field="nombre" value-field="count">
      <DxLabel :visible="true">
        <DxConnector :visible="true" :width="1" />
      </DxLabel>
    </DxSeries>
    <DxTooltip
      :enabled="true"
      :customize-tooltip="customizeTooltipPie"
      location="edge"
    />
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxExport :enabled="true" />
  </DxPieChart>
  <DxPieChart
    v-if="chartStatus == 'two' && typeChart == 'torta'"
    id="pie"
    :data-source="chartDataTwoParams.data1"
    :inner-radius="0.2"
    type="doughnut"
    palette="Ocean"
    @point-click="pointClickHandler($event)"
    @legend-click="legendClickHandler($event)"
  >
    <DxTitle text="Sistema de registro penitenciario">
      <!-- <DxSubtitle text="(billion US$, 2012)" /> -->
    </DxTitle>
    <DxZoomAndPan argument-axis="both" value-axis="both" />
    <DxLegend :visible="true" />
    <DxExport :enabled="true" />
    <DxCommonSeriesSettings>
      <DxLabel :visible="true">
        <DxConnector :visible="true" :width="1" />
      </DxLabel>
    </DxCommonSeriesSettings>
    <DxTooltip
      :enabled="true"
      location="edge"
      :customize-tooltip="customizeTooltipPie2"
    />
    <template
      v-for="(item, key, index) in chartDataTwoParams.data2"
      :key="index"
    >
      <DxSeries
        :name="item.data2"
        argument-field="nombre"
        :value-field="item.data2"
      />
    </template>
    <!-- <DxSeries name="data2" argument-field="nombre" value-field="data2" />
    <DxSeries name="data1" argument-field="nombre" value-field="data1" /> -->
  </DxPieChart>
  <modal-filiation></modal-filiation>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { defineComponent, ref, onMounted, computed } from "vue";
import modalFiliation from "@/views/filiation/modalFiliation.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import useSegip from "@/filiation/composables/useFiliation";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";
//import { useRouter } from "vue-router";
import {
  DxDataGrid,
  DxFilterRow,
  DxColumn,
  DxExport,
  DxSelection,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxPaging,
  DxPager,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  //DxButton,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import DxChart, {
  DxValueAxis,
  DxArgumentAxis,
  DxLegend,
  DxLabel,
  DxSeriesTemplate,
  DxCommonSeriesSettings,
  DxTooltip,
  DxZoomAndPan,
} from "devextreme-vue/chart";
import DxPieChart, {
  DxSeries,
  DxConnector,
  DxTitle,
} from "devextreme-vue/pie-chart";
import "devextreme/dist/css/dx.light.css";
export default defineComponent({
  name: "private-liberty-list",
  components: {
    DxDataGrid,
    DxFilterRow,
    DxColumn,
    DxExport,
    DxSelection,
    DxGroupPanel,
    DxGrouping,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxTotalItem,
    DxSeriesTemplate,
    DxCommonSeriesSettings,

    DxChart,
    DxValueAxis,
    DxArgumentAxis,
    DxLabel,
    DxLegend,
    DxTooltip,
    DxZoomAndPan,

    DxPieChart,
    DxSeries,
    DxConnector,
    DxTitle,

    modalFiliation,
    PulseLoader,
  },
  setup() {
    const pointClickHandler = (e) => {
      toggleVisibility(e.target);
    };
    const legendClickHandler = (e) => {
      const arg = e.target;
      const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

      toggleVisibility(item);
    };
    const toggleVisibility = (item) => {
      item.isVisible() ? item.hide() : item.show();
    };
    let typeChart = ref();
    let loading = ref(false);
    let dataGridRef = ref();
    let selectedRowsData = [];
    let colCount = ref(0);
    let colNames = [];
    let dataValuesFiltered = [];
    const dataGrid = computed(() => {
      return dataGridRef.value.instance;
    });
    const customizeTooltip = (pointInfo) => {
      return {
        text: `${pointInfo.argument} <br> ${pointInfo.seriesName} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad`,
      };
    };
    const customizeTooltip1 = (pointInfo) => {
      return {
        text: `${pointInfo.seriesName} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad`,
      };
    };
    const customizeTooltipPie = (pointInfo) => {
      return {
        text: `${pointInfo.argument} <br> ${pointInfo.valueText} persona(s) privada(s) de libertad (${pointInfo.percentText})`,
      };
    };
    const customizeTooltipPie2 = (pointInfo) => {
      return {
        text: `${pointInfo.seriesName}<br>${pointInfo.argumentText}<br>${pointInfo.valueText} persona(s) privadas de libertad (${pointInfo.percentText})`,
      };
    };
    const getSelectedData = async (value) => {
      if (value == 1) {
        typeChart.value = "barras";
      } else if (value == 2) {
        typeChart.value = "torta";
      }
      loading.value = true;
      selectedRowsData.push(dataGrid.value.getSelectedRowsData());
      for (let i = 0; i < dataGrid.value.columnCount(); i++) {
        if (dataGrid.value.columnOption(i, "groupIndex") > -1) {
          colCount.value++;
          colNames.push(dataGrid.value.columnOption(i, "dataField"));
        }
      }
      const { data } = await chartData({
        col: colNames,
        data: selectedRowsData,
      });
      data ? (loading.value = false) : (loading.value = true);
      if (data) {
        Swal.fire({
          title: "Generado",
          text: "El gráfico fue generado con éxito.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      } else {
        loading.value = false;
        Swal.fire({
          title: "Error",
          text: "Debe agrupar y seleccionar datos para generar el gráfico.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
      selectedRowsData = [];
      colCount = ref(0);
      colNames = [];
      //(dataValuesFiltered = []), dataGrid.value.clearFilter();
      //dataGrid.value.clearGrouping();
      //dataGrid.value.clearSelection();
    };
    loadMessages(esMessages);
    locale(navigator.language);
    //const router = useRouter();
    const DateFormat = (elements) => {
      const months = [
        "ENE",
        "FEB",
        "MAR",
        "ABR",
        "MAY",
        "JUN",
        "JUL",
        "AGO",
        "SEP",
        "OCT",
        "NOV",
        "DIC",
      ];

      let formatted_date =
        elements.getDate() +
        "-" +
        months[elements.getMonth()] +
        "-" +
        elements.getFullYear();
      return formatted_date;
    };
    const {
      PrivateLibertyList,
      countPersonsCenters,
      listPpl,
      countCentersByPersons,
      chartData,
      chartDataValues,
      chartDataTwoParams,
      chartStatus,
      passData,
    } = useSegip();
    const pplList = async () => {
      await PrivateLibertyList();
    };
    const countByCenter = async () => {
      await countPersonsCenters();
    };
    const pageSizes = ref([10, 25, 50, 100]);
    const onExporting = (e) => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("tableData");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "SirepReport.xlsx"
          );
        });
      });
      e.cancel = true;
    };
    const editData = async (e) => {
      await passData({ id_persona: e.id_persona, id_casoppl: e.id_casoppl });
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Lista privados de libertad", ["Filiación"]);
      pplList();
      countByCenter();
    });
    return {
      pointClickHandler,
      legendClickHandler,
      toggleVisibility,
      typeChart,
      loading,
      dataGridRef,
      dataGrid,
      selectedRowsData,
      getSelectedData,
      colCount,
      colNames,
      dataValuesFiltered,
      listPpl,
      countCentersByPersons,
      chartDataValues,
      chartDataTwoParams,
      chartStatus,
      pplList,
      countByCenter,
      pageSizes,
      DateFormat,
      onExporting,
      editData,
      customizeTooltip,
      customizeTooltip1,
      customizeTooltipPie,
      customizeTooltipPie2,
    };
  },
});
</script>
<style>
#chart {
  height: 800px;
  width: 100%;
}
#chart1 {
  height: 1000px;
  width: 100%;
}
#pie {
  height: 700px;
}
</style>
